/* eslint-disable */
let _markers = [];
const $ = require('jquery');
$(() => {
	if ($('body').hasClass('page-template-home')) {
		submitFilters();
		showFilters();
		closeFilters();
		searchFromLabelToggle();
	}
});

function clearSelections() {
	let $inputs = $('.home-search__filters input[type=checkbox]');
	// console.log($inputs);
	$inputs.each(function (index) {
		if ($(this).hasClass('active')) {
			$(this).removeClass('active');
			$(this).prop('checked', false);
			$(this).parent().removeClass('active');
			$(this).parent().prev().removeClass('active');//remove   also the --links filters
		}
	});
}

///Submit filter villas overview
function submitFilters() {
	$('.home-search__filters input[type=checkbox]').on('click', function (event) {
		if ($(this).hasClass('active')) {
			clearSelections();
			// $('.allvillas__form').submit();
		} else {
			// clearSelections();
			$(this).addClass('active');
			$(this).parent().addClass('active');
			// $('.allvillas__form').submit();
		}
	});
}

function showFilters() {
	$('.home-search__filters-btn').on('click', function (e) {
		// e.preventDefault();
		$('.home-search__filters').removeClass('active');
		$('.home-search__filters').toggleClass('active');
	});
}

function closeFilters() {
	$('.home-search__filters-btn-close').on('click', function (e) {
		// e.preventDefault();
		$('.home-search__filters').toggleClass('active');
	});
}

function searchFromLabelToggle() {
	let $labels = $('.home-search__label');
	$labels.on('click', function () {
		if ($(this).next().hasClass('active')) {
			$(this).next().removeClass('active');
		} else {
			$('.home-search__label').next().removeClass('active');
			$(this).next().toggleClass('active');
		}
	});
}





